import { useQueryClient } from 'react-query';

import { useAppSocket } from '@/common/hooks';
import { BaseQueryParams } from '@/common/interfaces';

import {
  PagesCriticalCssGatewayKeys,
  PagesCriticalCssGenerationStatus,
  PagesCriticalCssGenerationStatusChangedPayload,
  PagesQueryKeys,
  useGetOneByIdPagesQuery,
  useGetPageCriticalCssQuery,
} from '@/modules/Pages';

export const useUpdatePagesCriticalCssGenerationStatus = (siteId: string, pageId: string): void => {
  const queryClient = useQueryClient();

  useAppSocket<PagesCriticalCssGenerationStatusChangedPayload>(
    PagesCriticalCssGatewayKeys.GenerationStatusChanged,
    ({ lastMessage }) => {
      if (!lastMessage || lastMessage.siteId !== siteId) return;

      const changedPage = lastMessage.pages.find((page) => page.pageId === pageId);
      if (!changedPage) return;

      const { generationStatus } = changedPage;

      queryClient.setQueryData<
        BaseQueryParams<typeof useGetPageCriticalCssQuery>['data'] | undefined
      >([PagesQueryKeys.GetPageCriticalCss, siteId, pageId], (data) => data && { ...data, generationStatus });

      queryClient.setQueryData<
        BaseQueryParams<typeof useGetOneByIdPagesQuery>['data'] | undefined
      >([PagesQueryKeys.GetOneByIdDossier, siteId, pageId],
        (data) => data && { ...data, pageCriticalCss: { ...data.pageCriticalCss, generationStatus } });

      if (generationStatus !== PagesCriticalCssGenerationStatus.Queued && generationStatus !== PagesCriticalCssGenerationStatus.Generating) {
        queryClient.invalidateQueries([PagesQueryKeys.GetPageCriticalCss, siteId, pageId]);
      }
    },
  );
};
